import request from '@lib/request'

// 获取机构信息
function EditInstitution({
  organName, // 全称
  shortName, // 简称
  message, // 描述
  address, // 地址
  organTel, // 联系电话
  codePic, // 机构二维码
  pics
}) {
  return request
    .post('/institutionAdmin/institution/edit', {
      name: organName,
      short_name: shortName,
      desc: message,
      address: address,
      mobile: organTel,
      contact_qrcode: codePic,
      pics: pics
    })
    .then(response => {
      return response.data
    })
}
// 获取机构品牌启动页信息
function GetBrandInfo({
  platform
}) {
  return request
    .get('/institutionAdmin/institution/getStartUp', {
      params: {
        keyword: platform
      }
    })
    .then(result => {
      return result.data
    })
}
// 获取机构品牌banner信息
function GetBanner({
  platform
}) {
  return request
    .get('/institutionAdmin/banner/list', {
      params: {
        keyword: platform
      }
    })
    .then(result => {
      return result.data
    })
}
// 设置启动页
function SetStartPage({
  pic,
  template
}) {
  return request
    .post('/institutionAdmin/institution/setStartUp', {
      pic,
      template
    })
    .then(response => {
      return response.data
    })
}
// 移除bannerID
function DeleteBanner({
  id,
  type
}) {
  return request
    .post('/institutionAdmin/banner/del', {
      id,
      type
    })
    .then(response => {
      return response.data
    })
}

// 新建banner
function AddBanner({
  pic,
  url,
  sort
}) {
  return request
    .post('/institutionAdmin/banner/add', {
      pic,
      url,
      sort
    })
    .then(response => {
      return response.data
    })
}

function GetStudentInfo({
  id
}) {
  return request
    .get('/saleManager/institutionBatch/queryData', {
      params: {
        institution_id: id
      }
    })
    .then(result => {
      return result.data
    })
}

function GetSimpleStudentInfo({
  id
}) {
  return request
    .get('/saleManager/institutionBatch/querySimpleData', {
      params: {
        institution_id: id
      }
    })
    .then(result => {
      return result.data
    })
}

function OrgInfo() {
  return request
    .get('/institutionAdmin/institution/info', {
      params: {

      }
    })
    .then(result => {
      return result.data
    })
}
// 编辑banner
function EditBanner({
  id,
  pic,
  url,
  sort
}) {
  return request
    .post('/institutionAdmin/banner/edit', {
      id,
      pic,
      url,
      sort
    })
    .then(response => {
      return response.data
    })
}

const GetPoster = ({
  url,
  name,
  selector
}) => {
  return request
    .post('https://screenshot.qupeiyin.cn/GetPoster', {
      url,
      name,
      selector
    }, {
      needSign: true,
      noToken: true
    })
    .then(result => {
      return result.data
    })
}

export default {
  EditInstitution,
  GetBrandInfo,
  SetStartPage,
  GetBanner,
  DeleteBanner,
  AddBanner,
  EditBanner,
  GetStudentInfo,
  GetSimpleStudentInfo,
  OrgInfo,
  GetPoster
}
